// extracted by mini-css-extract-plugin
export default {"errorPage":"NotFound_errorPage__8eHZJ","iconCircle":"NotFound_iconCircle__Dc3gG","shake":"NotFound_shake__sTpWv"};